enum FundGeographyType {
    GLOBALT = 'Globalt',
    NORSK = 'Norsk',
    NORDISK = 'Nordisk',
    ASIATISK = 'Asiatisk',
    EUROPEISK = 'Europeisk',
    AMERIKANSK = 'Amerikansk',
    ANDRE = 'Andre',
    UDEFINERT = 'Udefinert'
}

export default FundGeographyType;